import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';

import { MaterialModule } from './material/material.module';

import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { EmpLoginComponent } from '../login/emp-login.component';
import { VendorLoginComponent } from '../vendor-login/vendor-login.component';
import { VendorHeaderComponent } from './vendor-header/vendor-header.component';
import { NoDataFoundComponent } from './no-data-found/no-data-found.component';
import { VendorSidebarComponent } from './vendor-sidebar/vendor-sidebar/vendor-sidebar.component';
import { SidebarComponent } from './sidebar/sidebar/sidebar.component';
import { CurrencySymbolPipe } from './Pipe/currency-symbol.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { GroupchatComponent } from './group-chat/groupchat/groupchat.component';
import { AnnouncementlistComponent } from './announcementlist/announcementlist.component';
import { AddAnnouncementlistComponent } from './add-announcementlist/add-announcementlist.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';




@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    EmpLoginComponent,
    VendorLoginComponent,
    VendorHeaderComponent,
    NoDataFoundComponent,
    SidebarComponent,
    VendorSidebarComponent,
    CurrencySymbolPipe,
    GroupchatComponent,
    AnnouncementlistComponent,
    AddAnnouncementlistComponent,
    ConfirmationDialogComponent,
  
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    HeaderComponent,
    FooterComponent,
    VendorHeaderComponent,
    NoDataFoundComponent,
    SidebarComponent,
    VendorSidebarComponent,
    CurrencySymbolPipe
  ]
})
export class SharedModule { }